import {HttpClient} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {EMPTY, interval, Observable, of, Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import {PrlInitializer} from './prl-initializer.interface';
import {Router} from '@angular/router';
import {
    PrlTermsAndConditionsPageService
} from '../../view/prl-authentication/services/terms-and-conditions-page/prl-terms-and-conditions-page.service';
import {PrlAuthenticationService} from './prl-authentication.service';

const TOKEN_EXPIRED = 'expired';

@Injectable({
    providedIn: 'root'
})
export class PrlAuthPingService implements PrlInitializer {
    private _destroy$$: Subject<null> = new Subject<null>();
    private authService: PrlAuthenticationService;

    constructor(private httpClient: HttpClient,
                private prlTermsAndConditionsPageService: PrlTermsAndConditionsPageService,
                private injector: Injector,
                private router: Router) {
    }

    init(): Observable<void> {
        this.authService = this.injector.get(PrlAuthenticationService);
        interval(60 * 1000)
            .pipe(
                takeUntil(this._destroy$$),
                switchMap(() => this.getPing()))
            .subscribe(resp => this.handlePingResponse(resp));
        return of(void 0);
    }

    private getPing(): Observable<any> {
        if (!this.authService.token) {
            return EMPTY;
        }

        this.prlTermsAndConditionsPageService.setIsTcAccepted().subscribe(isTcAccepted => {
            if (!isTcAccepted) {
                this.router.navigateByUrl('/terms');
            }
        });

        if (this.authService.isAuthTokenChanged()) {
            this.authService.invalidateAuth('label.login.automatic.logout.message');
            return EMPTY;
        }
        return this.httpClient.get('/rest/login/ping', {params: {ping: true}, responseType: 'text'});
    }

    private handlePingResponse(pingValue: string): void {
        if (!pingValue) {
            return;
        }

        if (pingValue === TOKEN_EXPIRED) {
            this.authService.invalidateAuth('label.login.errors.timeout.message');
        } else {
            this.authService.invalidateAuth(null);
        }
    }

    destroy(): void {
        this._destroy$$.next(null);
    }

}
